import dayjs from 'dayjs';

import type { DayJs, Time } from '@jane/shared/types';

export const convertToDayJs = (time: Time | number): DayJs => dayjs(time);
